import React, { memo } from "react";
import Anima from "../../Anima/index";
import LazyImage from "../../LazyImage";

const LazyAnima = memo(() => {
  return (
    <Anima className="w-56" json={"/keys/dialogs/send_money_$.json"} center />
  );
});

const SendMoney = () => {
  return <LazyImage anima={LazyAnima} />;
};

export default SendMoney;
